var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.768 11.296c-0.304-0.49011-0.8411-0.78307-1.4368-0.78307h-13.264c-0.65749 0-1.2554 0.37063-1.5239 0.9445l-3.5083 7.3557c0.13244 0.53866 0.63553 0.94099 1.2348 0.94099h14.112c0.60333 0 1.1548-0.34122 1.4243-0.88099l3.0323-6.0778c0.23944-0.481 0.21289-1.0414-0.07033-1.4993z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m4.8282 10.326c0.26809-0.57373 0.86622-0.94451 1.5239-0.94451h12.49v-1.5975c0-0.65856-0.55566-1.1944-1.2384-1.1944h-7.2829c-0.01068 0-0.018-0.00274-0.02075-0.00473l-1.3035-1.8227c-0.23086-0.32333-0.61217-0.51635-1.0196-0.51635h-4.7384c-0.68313 0-1.2387 0.53588-1.2387 1.1944v10.815z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.d44d381c37f3d3ad6942c6a14622e950.svg";
export { ForwardRef as ReactComponent };